<div class="ea-wrapper">
  <div class="ea-card">
    <!-- Header -->
    <div class="ea-header">
      <span class="ea-header__eyebrow">{{
        "EDIT_APPOINTMENT.EYEBROW" | translate
      }}</span>
      <h2 class="ea-header__company">{{ companyName || "Sagel" }}</h2>
      <p class="ea-header__id">
        {{ "EDIT_APPOINTMENT.ID_LABEL" | translate }}:
        <strong>{{ reservationId }}</strong>
      </p>
    </div>

    <!-- Loading -->
    @if (isLoading) {
    <div class="ea-loading">
      <div class="spinner-border" role="status" aria-hidden="true"></div>
    </div>
    }

    <!-- Form -->
    @if (!isLoading && success === null) {
    <div class="ea-body">
      <p class="ea-body__intro">{{ "EDIT_APPOINTMENT.INTRO" | translate }}</p>
      <!-- Stepper -->
      <div class="ea-steps">
        <div
          class="ea-step"
          [class.ea-step--active]="currentStep === 1"
          [class.ea-step--done]="currentStep > 1"
        >
          <span class="ea-step__num">1</span>
          <span class="ea-step__label">{{
            "EDIT_APPOINTMENT.STEP1_TITLE" | translate
          }}</span>
        </div>
        <span class="ea-step__sep"></span>
        <div class="ea-step" [class.ea-step--active]="currentStep === 2">
          <span class="ea-step__num">2</span>
          <span class="ea-step__label">{{
            "EDIT_APPOINTMENT.STEP2_TITLE" | translate
          }}</span>
        </div>
      </div>
      <div class="ea-form">
        <!-- ── STEP 1: service, date & time ──────────────────────────────── -->
        @if (currentStep === 1) { @if (catalog.length) {
        <div class="ea-field">
          <label class="ea-field__label">{{
            "EDIT_APPOINTMENT.SERVICE" | translate
          }}</label>
          <select
            class="ea-field__input"
            [(ngModel)]="selectedService"
            (ngModelChange)="onServiceChange()"
            name="service"
          >
            <option [ngValue]="null" disabled>
              {{ "EDIT_APPOINTMENT.SERVICE_PLACEHOLDER" | translate }}
            </option>
            @for (s of catalog; track s) {
            <option [ngValue]="s">
              {{ s.name }} ·
              {{
                "EDIT_APPOINTMENT.DURATION_PILL"
                  | translate : { minutes: s.durationMin }
              }}
            </option>
            }
          </select>
        </div>
        }
        <div class="ea-field-row">
          <div class="ea-field">
            <label class="ea-field__label">{{
              "EDIT_APPOINTMENT.DATE" | translate
            }}</label>
            <c-date-picker
              closeOnSelect
              name="date"
              locale="en-GB"
              format="dd/MM/yyyy"
              [ngModel]="dateModel"
              [ngModelOptions]="{ standalone: true }"
              [minDate]="minDate"
              [disabledDates]="fullyClosedDates"
              [dateFilter]="dateFilter"
              (ngModelChange)="onDateChange($event)"
            ></c-date-picker>
          </div>
        </div>
        <!-- Time slots (15-min increments, availability-aware) -->
        @if (selectedService) {
        <div class="ea-field">
          <label class="ea-field__label">
            {{ "EDIT_APPOINTMENT.TIME" | translate }}
            @if (time) {
            <span class="ea-slot-ends"
              >·
              {{
                "EDIT_APPOINTMENT.ENDS_AT" | translate : { time: endTime }
              }}</span
            >
            }
          </label>
          @if (slotsLoading) {
          <div class="ea-slots-loading">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ "EDIT_APPOINTMENT.SLOT_CHECKING" | translate }}
          </div>
          } @if (!slotsLoading && slotsUnavailable) {
          <p class="ea-slots-empty">
            {{ "EDIT_APPOINTMENT.NO_SLOTS" | translate }}
          </p>
          } @if (!slotsLoading && daySlots.length) {
          <div class="ea-slots">
            @for (slot of daySlots; track slot) {
            <button
              type="button"
              class="ea-slot-chip"
              [class.ea-slot-chip--active]="time === slot"
              (click)="selectSlot(slot)"
            >
              {{ slot }}
            </button>
            }
          </div>
          }
        </div>
        } @if (stepError) {
        <p class="ea-step-error" role="alert">{{ stepError }}</p>
        }
        <button type="button" class="ea-btn-save" (click)="nextStep()">
          {{ "EDIT_APPOINTMENT.NEXT" | translate }}
        </button>
        }
        <!-- ── STEP 2: your details ──────────────────────────────────────── -->
        @if (currentStep === 2) {
        <div class="ea-field">
          <label class="ea-field__label">{{
            "EDIT_APPOINTMENT.NAME" | translate
          }}</label>
          <input class="ea-field__input" type="text" [(ngModel)]="name" />
        </div>
        <div class="ea-field-row">
          <div
            class="ea-field"
            [class.ea-field--invalid]="
              contactValidationAttempted && !isEmailValid()
            "
          >
            <label class="ea-field__label">
              {{ "EDIT_APPOINTMENT.EMAIL" | translate }}
              <span class="ea-field__required" aria-hidden="true">*</span>
            </label>
            <input
              class="ea-field__input"
              type="email"
              [(ngModel)]="email"
              autocomplete="email"
              inputmode="email"
              required
              [attr.aria-invalid]="
                contactValidationAttempted && !isEmailValid()
              "
              aria-describedby="appointment-email-error"
            />
            @if (contactValidationAttempted && !isEmailValid()) {
            <small id="appointment-email-error" class="ea-field__error">
              {{ "EDIT_RESERVATION.EMAIL_REQUIRED" | translate }}
            </small>
            }
          </div>
          <div
            class="ea-field"
            [class.ea-field--invalid]="
              contactValidationAttempted && !isPhoneValid()
            "
          >
            <label class="ea-field__label">
              {{ "EDIT_APPOINTMENT.PHONE" | translate }}
              <span class="ea-field__required" aria-hidden="true">*</span>
            </label>
            <input
              class="ea-field__input"
              type="tel"
              [(ngModel)]="phone"
              autocomplete="tel"
              inputmode="tel"
              pattern="[0-9+() -]{7,20}"
              maxlength="20"
              required
              [attr.aria-invalid]="
                contactValidationAttempted && !isPhoneValid()
              "
              aria-describedby="appointment-phone-error"
            />
            @if (contactValidationAttempted && !isPhoneValid()) {
            <small id="appointment-phone-error" class="ea-field__error">
              {{ "EDIT_RESERVATION.PHONE_REQUIRED" | translate }}
            </small>
            }
          </div>
        </div>
        <div class="ea-field">
          <label class="ea-field__label">{{
            "EDIT_APPOINTMENT.NOTES" | translate
          }}</label>
          <textarea
            class="ea-field__input ea-field__input--textarea"
            [(ngModel)]="notes"
            rows="3"
          ></textarea>
        </div>
        <app-altcha
          action="update_reservation"
          (tokenChange)="captchaToken = $event"
          (readyChange)="captchaReady = $event"
        ></app-altcha>
        @if (errorMessage) {
        <p class="ea-step-error" role="alert">{{ errorMessage }}</p>
        }
        <div class="ea-nav">
          <button type="button" class="ea-btn-back" (click)="prevStep()">
            {{ "EDIT_APPOINTMENT.BACK" | translate }}
          </button>
          <button
            class="ea-btn-save"
            (click)="save()"
            [attr.aria-busy]="isSaving"
          >
            @if (isSaving) {
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            }
            {{
              isSaving
                ? ("EDIT_APPOINTMENT.SAVING" | translate)
                : ("EDIT_APPOINTMENT.SAVE" | translate)
            }}
          </button>
        </div>
        }
      </div>
    </div>
    }

    <!-- Success / Error state -->
    @if (success !== null) {
    <div class="ea-body ea-result">
      <div
        class="ea-result__icon"
        [class.ea-result__icon--success]="success"
        [class.ea-result__icon--error]="!success"
      >
        @if (success) {
        <svg [cIcon]="icons.cilCheckCircle" size="xl"></svg>
        } @if (!success) {
        <svg [cIcon]="icons.cilXCircle" size="xl"></svg>
        }
      </div>
      <h3 class="ea-result__title">
        {{
          success
            ? ("EDIT_APPOINTMENT.SUCCESS_TITLE" | translate)
            : ("EDIT_APPOINTMENT.ERROR_TITLE" | translate)
        }}
      </h3>
      <p class="ea-result__message">
        {{
          success
            ? ("EDIT_APPOINTMENT.SUCCESS_TEXT" | translate)
            : errorMessage || ("EDIT_APPOINTMENT.ERROR_TEXT" | translate)
        }}
      </p>
      @if (!success) {
      <button class="ea-btn-retry" (click)="success = null">
        {{ "EDIT_APPOINTMENT.TRY_AGAIN" | translate }}
      </button>
      }
    </div>
    }

    <!-- Footer -->
    <div class="ea-footer">
      <span class="ea-footer__powered">Powered by</span>
      <img
        src="assets/img/brand/SAGEL_LOGO.svg"
        alt="Sagel"
        class="ea-footer__logo"
      />
    </div>
  </div>
</div>
